import React from "react";
import { Breadcrumb, Row, Col, Space, Card } from "antd";
import { BrowserRouter as Router, NavLink } from "react-router-dom";
function ProcessSetting() {
  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Master Settings </Breadcrumb.Item>
        <Breadcrumb.Item>Process Settings</Breadcrumb.Item>
      </Breadcrumb>
      <div
        className="site-layout-background"
        style={{ padding: 24, minHeight: 360 }}
      >
        <h2 className="titles">
          PROCESS <span>SETTINGS</span>
        </h2>
        <p>Select View</p>
        <Row>
          <Col xs={12} xl={8}>
            <div className="LinksCard">
              <NavLink to="/new-process">
                <span className="icons icon-new-receipt"></span>
                Add New Processes
              </NavLink>
            </div>
          </Col>
          <Col xs={12} xl={8}>
            <div className="LinksCard">
              <NavLink to="/process-list">
                <span className="icons icon-view-all-receipt"></span>
                View / Manage Processes
              </NavLink>
            </div>
          </Col>
        </Row>
        <br></br>
        <br></br>
      </div>
    </div>
  );
}

export default ProcessSetting;
